import React from 'react'

type SourceLogoProps = {
  icon: JSX.Element
}

export default function SourceLogo({ icon }: SourceLogoProps): JSX.Element {
  return (
    <div className="flex justify-center items-center w-[60px] h-[60px] rounded-full bg-white-smoke p-1">
      {icon}
    </div>
  )
}
